import Vue from 'vue'
import VueCodemirror from 'vue-codemirror'

import 'codemirror/lib/codemirror.css'

Vue.use(VueCodemirror, {
  options: { theme: 'Monokai', mode: 'text/javascript' }
})
